import axios from 'axios'
export default {
	data: () => ({
		loading: false,
	}),

	props: {
		value: 			{ type: [Object,String], default: () => {} },
		defaultIndex:  		{ type: Number, default: -1},
		//default:  		{ type: [Number, Object], default: null},
		label:  		{ type: String, default: 'Тип'},
		placeholder:  	{ type: String, default: null},
		hint:  			{ type: String, default: null},
		persistentHint:	{ type: Boolean, default: false },
		readonly:		{ type: Boolean, default: false },
		clearable:		{ type: Boolean, default: false },
		outlined: 		{ type: Boolean, default: false },
		dense: 			{ type: Boolean, default: false },
		//prependIcon:  	{ type: String, default: null}, //"mdi-calendar
		hideDetails: 	{ type: [Boolean, String], default: 'auto' },
		rules:			{ type: Array, default: () => [] },
	},

	computed: {
		model: {
			get() 		{ return this.value },
			set(val) 	{ this.$emit('input', val) }
		},
	},

	created () {
		this.onLoad();
	},
	
	methods: {

		setItems() { },

		setDefault() { 
			if(this.defaultIndex >= 0 && this.defaultIndex < this.items.length) {
				//console.log('combobox:mixin', 'onLoad', 'defaultIndex', this.defaultIndex)
				this.model = this.items[this.defaultIndex]
			}
		},

		onClear() {
			this.setItems()
			this.model = null
		},

		onLoad() {
			this.loading = true;
			this.load().then(() => {
				//console.log('combobox:mixin', 'onLoad', 'defaultIndex', this.defaultIndex)
				this.setDefault();
			}).finally(() => (this.loading = false));
		},

		onRefresh(item) {
			if(item) {
				this.onLoad()
			} else {
				this.onClear()
			} 
		},
	},
}